/* tslint:disable */
/* eslint-disable */
/**
 * Admin Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { PageableObject } from './PageableObject';
import {
    PageableObjectFromJSON,
    PageableObjectFromJSONTyped,
    PageableObjectToJSON,
    PageableObjectToJSONTyped,
} from './PageableObject';
import type { UsersDTO } from './UsersDTO';
import {
    UsersDTOFromJSON,
    UsersDTOFromJSONTyped,
    UsersDTOToJSON,
    UsersDTOToJSONTyped,
} from './UsersDTO';
import type { SortObject } from './SortObject';
import {
    SortObjectFromJSON,
    SortObjectFromJSONTyped,
    SortObjectToJSON,
    SortObjectToJSONTyped,
} from './SortObject';

/**
 * 
 * @export
 * @interface PageUsersDTO
 */
export interface PageUsersDTO  {
    /**
     * 
     * @type {number}
     * @memberof PageUsersDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageUsersDTO
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof PageUsersDTO
     */
    size?: number;
    /**
     * 
     * @type {Array<UsersDTO>}
     * @memberof PageUsersDTO
     */
    content?: Array<UsersDTO>;
    /**
     * 
     * @type {number}
     * @memberof PageUsersDTO
     */
    number?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageUsersDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageUsersDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageUsersDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PageUsersDTO
     */
    sort?: SortObject;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageUsersDTO
     */
    pageable?: PageableObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageUsersDTO
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the PageUsersDTO interface.
 */
export function instanceOfPageUsersDTO(value: object): value is PageUsersDTO {
    return true;
}

export function PageUsersDTOFromJSON(json: any): PageUsersDTO {
    return PageUsersDTOFromJSONTyped(json, false);
}

export function PageUsersDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageUsersDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'totalElements': json['totalElements'] == null ? undefined : json['totalElements'],
                  'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
                  'size': json['size'] == null ? undefined : json['size'],
              'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(UsersDTOFromJSON)),
                  'number': json['number'] == null ? undefined : json['number'],
                  'first': json['first'] == null ? undefined : json['first'],
                  'last': json['last'] == null ? undefined : json['last'],
                  'numberOfElements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
                  'sort': json['sort'] == null ? undefined : SortObjectFromJSON(json['sort']),
                  'pageable': json['pageable'] == null ? undefined : PageableObjectFromJSON(json['pageable']),
                  'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function PageUsersDTOToJSON(json: any): PageUsersDTO {
    return PageUsersDTOToJSONTyped(json, false);
}

export function PageUsersDTOToJSONTyped(value?: PageUsersDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
        'size': value['size'],
        'content': value['content'] == null? value['content']: (value['content'] as Array<any>).map(UsersDTOToJSON),
        'number': value['number'],
        'first': value['first'],
        'last': value['last'],
        'numberOfElements': value['numberOfElements'],
        'sort': SortObjectToJSON(value['sort']),
        'pageable': PageableObjectToJSON(value['pageable']),
        'empty': value['empty'],
    };
}


